import { CREATE_DMX_DEVICE, CREATE_DMX_DEVICE_SUCCESSFUL, CREATE_DMX_DEVICE_FAILED } from './actionTypes';

export const createDmxDevice = (device) => {
  return {
    type: CREATE_DMX_DEVICE,
    payload: { device },
  };
};

export const createDmxDeviceSuccessful = (message) => {
  return {
    type: CREATE_DMX_DEVICE_SUCCESSFUL,
    payload: message,
  };
};

export const createDmxDeviceFailed = (message) => {
  return {
    type: CREATE_DMX_DEVICE_FAILED,
    payload: message,
  };
};
